import React, { useEffect, useState } from 'react';
import { animateScroll as scroll } from 'react-scroll';
//components
import Text from 'components/Text';
import { Visibility } from 'components/Visibility';
//assets
import { colors } from 'pages/Quotes/styles/colors';
import ScrollToTopArrow from 'img/scroll-to-top-arrow.svg';

import { ScrollToTopButtonContainer, ScrollToTopButton } from './styles';

export const ScrollToTop = () => {
  const [isButtonVisible, setIsButtonVisible] = useState(false);

  const toggleVisibility = () => {
    setIsButtonVisible(window.scrollY > 300);
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);

    return () =>
      window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <Visibility visible={isButtonVisible}>
      <ScrollToTopButtonContainer onClick={() => scroll.scrollToTop()}>
        <ScrollToTopButton>
          <img src={ScrollToTopArrow} />
          <Text color={colors.white}>
            Voltar ao topo
          </Text>
          <img src={ScrollToTopArrow} />
        </ScrollToTopButton>
      </ScrollToTopButtonContainer>
    </Visibility>
  );
};
